import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
export interface IState {
    usersError?: Error;
    userError?: Error;
    isFetchingUsers: boolean;
    isSavingUser: boolean;
    isDeletingUser: boolean;
    users: any[];
    permissions: string[];
}

export const initialState: IState = {
    usersError: undefined,
    userError: undefined,
    isFetchingUsers: false,
    isSavingUser: false,
    isDeletingUser: false,
    users: [],
    permissions: [],
};

const byName = (a, b) => {
    const x = a.name.toLowerCase();
    const y = b.name.toLowerCase();
    return x < y ? -1 : x > y ? 1 : 0;
};

export const utilitiesReducer = handleActions<IState, any>(
    {
        [UTILITIES.USERS.FETCH.START]: (state: IState) => {
            return {
                ...state,
                isFetchingUsers: true,
            };
        },
        [UTILITIES.USERS.FETCH.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    usersError: payload,
                    isFetchingUsers: false,
                };
            }
            return {
                ...state,
                users: payload.sort(byName),
                isFetchingUsers: false,
            };
        },
        [UTILITIES.USERS.CREATE.START]: (state: IState) => {
            return {
                ...state,
                isSavingUser: true,
            };
        },
        [UTILITIES.USERS.CREATE.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    userError: payload,
                    isSavingUser: false,
                };
            }
            return {
                ...state,
                users: payload.account_type === "nuorder" ? state.users.concat(payload).sort(byName) : state.users,
                isSavingUser: false,
            };
        },
        [UTILITIES.USERS.EDIT.START]: (state: IState) => {
            return {
                ...state,
                isSavingUser: true,
            };
        },
        [UTILITIES.USERS.EDIT.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    userError: payload,
                    isSavingUser: false,
                };
            }

            return {
                ...state,
                users: state.users.sort(byName).map((user) => (user._id === payload._id ? payload : user)),
                isSavingUser: false,
            };
        },
        [UTILITIES.USERS.DELETE.START]: (state: IState) => {
            return {
                ...state,
                isDeletingUser: true,
            };
        },
        [UTILITIES.USERS.DELETE.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    userError: payload,
                    isDeletingUser: false,
                };
            }
            const { id } = payload;
            return {
                ...state,
                users: state.users.filter((user) => user._id !== id),
                isDeletingUser: false,
            };
        },
        [UTILITIES.USERS.DISABLE.START]: (state: IState) => {
            return {
                ...state,
                isDisablingUser: true,
            };
        },
        [UTILITIES.USERS.DISABLE.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    userError: payload,
                    isDisablingUser: false,
                };
            }

            return {
                ...state,
                isDisablingUser: false,
            };
        },
        [UTILITIES.USERS.RESTORE.START]: (state: IState) => {
            return {
                ...state,
                isRestoringUser: true,
            };
        },
        [UTILITIES.USERS.RESTORE.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    userError: payload,
                    isRestoringUser: false,
                };
            }

            return {
                ...state,
                isRestoringUser: false,
            };
        },
        [UTILITIES.USER_PERMISSION_TYPES.FETCH.START]: (state: IState) => {
            return {
                ...state,
            };
        },
        [UTILITIES.USER_PERMISSION_TYPES.FETCH.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                };
            }

            const permissions = payload || [];

            return {
                ...state,
                permissions,
            };
        },
    },
    initialState,
);
